import { memo, useEffect, useState } from 'react';
import { Typography, Slider, message } from 'antd';
import { CheckCircleTwoTone } from '@ant-design/icons';
import { getTaskId, getTranslateText } from '@/apis';
import queryDomMethods from '@/utils/query-dom-methods';
import moment from 'moment';
import classNames from 'classnames';
import './index.scss';

const { Text } = Typography;

interface IProps {
    linkContent: string; // 翻译内容
    linkTime: number; // 时间
    linkFile: string; // 音频地址
    audioKey: string; // 请给所有的音频控件唯一的key，用来获取识别当前标签
    className?: string;
}

const AudioPlayer = (props: IProps) => {
    const { audioKey, linkContent, linkTime, linkFile } = props;

    const [value, setValue] = useState(0);
    const [showTranslate, setShowTranslate] = useState(false);
    const [translateText, setTranslateText] = useState('');
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState('paused');
    const [showTranslateWrapper, setTranslateWrapper] = useState(false);

    const playIcon = 'https://simg01.gaodunwangxiao.com/uploadfiles/files/202409/26/45414_20240926160512.png';
    const pauseIcon = 'https://simg01.gaodunwangxiao.com/uploadfiles/files/202409/26/f117f_20240926160501.png';

    const init = () => {
        setTranslateText(linkContent);
    };

    useEffect(() => {
        init();
    }, []);

    const allPause = () => {
        const audioArr: any = queryDomMethods.querySelectorAll('.audio-wrapper audio');
        const imgArr: any = queryDomMethods.querySelectorAll('.play-btn');
        for (let i = 0; i < audioArr.length; i++) {
            audioArr[i].pause();
            imgArr[i].src = pauseIcon;
        }
    };

    const audioLister = (dom: HTMLAudioElement, img: HTMLImageElement) => {
        dom.addEventListener('timeupdate', () => {
            setValue(dom.currentTime);
            if (dom.currentTime === dom.duration) {
                setValue(0);
                img.src = pauseIcon;
            }
        });
        dom.addEventListener('playing', () => {
            setStatus('playing');
        });
        dom.addEventListener('pause', () => {
            setStatus('paused');
        });
        if (status === 'paused') {
            dom.play();
            // @ts-ignore
            if (img.src === pauseIcon) {
                img.src = playIcon;
            }
        } else {
            dom.pause();
            if (img.src === playIcon) {
                img.src = pauseIcon;
            }
        }
    };

    const play = () => {
        allPause();
        const audioDom = queryDomMethods.querySelector(`.${audioKey}>audio`) as HTMLAudioElement;
        const img = queryDomMethods.querySelector(`.play-btn-${audioKey}`) as HTMLImageElement;
        audioLister(audioDom, img);
    };

    const drag = (v: number) => {
        allPause();
        const audioDom = queryDomMethods.querySelector(`.${audioKey}>audio`) as HTMLAudioElement;
        setValue(v);
        audioDom.currentTime = v;
    };

    const afterChange = () => {
        allPause();
        const audioDom = queryDomMethods.querySelector(`.${audioKey}>audio`) as HTMLAudioElement;
        const img = queryDomMethods.querySelector(`.play-btn-${audioKey}`) as HTMLImageElement;
        audioLister(audioDom, img);
        audioDom.play();
        img.src = playIcon; // this.playIcon;
    };

    const translate = () => {
        let time = linkTime / 10;
        time = time >= 2000 ? time : 2000;
        if (!showTranslateWrapper) {
            setShowTranslate(true);
            setTranslateWrapper(true);
            setLoading(true);
            setTimeout(() => setLoading(false), time);
        }
    };

    const retry = async () => {
        setLoading(true);
        const { result } = await getTaskId({ fileLink: linkFile });
        if (!result?.taskId) {
            setLoading(false);
            return;
        }
        const { result: translateResult } = await getTranslateText({ taskId: result.taskId });
        if (!translateResult?.answerContent) {
            setLoading(false);
            return;
        }
        setTranslateText(translateResult.answerContent);
        setLoading(false);
    };

    return (
        <div className={classNames('audio-card', props.className)}>
            <div className={`audio-wrapper ${audioKey}`} onClick={e => e.stopPropagation()}>
                <audio src={linkFile} />
                <div className="audio-controller">
                    <img className={`play-btn play-btn-${audioKey}`} src={pauseIcon} onClick={play} />
                    <div className="audio-controller-slider">
                        <Slider
                            max={linkTime / 1000}
                            step={0.01}
                            value={value}
                            onChange={(v: any) => drag(v)}
                            onAfterChange={afterChange}
                        />
                        <div className="audio-time">
                            <span>{moment(value * 1000).format('mm:ss')}</span>
                            <span>{moment(linkTime).format('mm:ss')}</span>
                        </div>
                    </div>

                    <span className="to-text" onClick={translate}>
                        转文字
                    </span>
                </div>
                {showTranslateWrapper && (
                    <>
                        {showTranslate && !loading ? (
                            <div className="translate-content">
                                {translateText ? (
                                    <>
                                        {translateText}
                                        <div className="gutter-row success-text">
                                            <CheckCircleTwoTone twoToneColor="#00d14d" />
                                            <Text type="secondary" className="font-size-12">
                                                转换完成
                                            </Text>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <div className="success-text">
                                            {!loading ? (
                                                <>
                                                    <Text type="secondary">转换失败</Text>
                                                    <span className="font-size-12 to-text" onClick={retry}>
                                                        重试
                                                    </span>
                                                </>
                                            ) : (
                                                <>
                                                    <Text style={{ display: 'block', width: '100%' }} type="secondary">
                                                        转换中...
                                                    </Text>
                                                    <div>
                                                        <img
                                                            width={46}
                                                            src="https://simg01.gaodunwangxiao.com/uploadfiles/files/202409/27/a7ce9_20240927095244.gif"
                                                        />
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    </>
                                )}
                            </div>
                        ) : (
                            <div className="text-center">
                                <Text style={{ display: 'block', marginBottom: 10 }} type="secondary">
                                    转换中...
                                </Text>
                                <div>
                                    <img
                                        width={46}
                                        src="https://simg01.gaodunwangxiao.com/uploadfiles/files/202409/27/a7ce9_20240927095244.gif"
                                    />
                                </div>
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};

export default memo(AudioPlayer);
